var o = Function.prototype, n = o.toString;
function e(t) {
  if (t != null) {
    try {
      return n.call(t);
    } catch (r) {
    }
    try {
      return t + "";
    } catch (r) {
    }
  }
  return "";
}
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_toSource.js
// module id = 923
// module chunks = 67